import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-secondary-300">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-black font-heading text-background-50 tracking-tight">
                黑料舍
              </span>
            </Link>
            <p className="text-sm text-secondary-400 leading-relaxed">
              深度内幕，全网独家爆料平台。汇聚娱乐圈、商业、社会各领域不为人知的真实黑料，带你看透表象背后的真相。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50 mb-3">内容分类</h3>
            <ul className="flex flex-col gap-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50 mb-3">关于我们</h3>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/about" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer">
                  联系我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50 mb-3">关注我们</h3>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 hover:bg-primary-600 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-background-50 text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 hover:bg-primary-600 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-background-50 text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 hover:bg-primary-600 transition-colors cursor-pointer" aria-label="RSS">
                <i className="ri-rss-line text-background-50 text-base"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-500">
            &copy; {new Date().getFullYear()} 黑料舍 版权所有 | 京ICP备XXXXXXXX号-1
          </p>
          <p className="text-xs text-secondary-500">
            本站内容仅供信息参考，不构成任何建议
          </p>
        </div>
      </div>
    </footer>
  );
}